import React from "react";
import { Table, Badge, Alert } from "reactstrap";

/**
 * Komponen untuk menampilkan alert obat expired atau mendekati expired
 * @param {Array} data - Data stok
 */
export default function ExpiredAlert({ data }) {
  if (!data || data.length === 0) {
    return <Alert color="info">Tidak ada data stok untuk ditampilkan.</Alert>;
  }

  // Filter obat yang expired atau mendekati expired (30 hari)
  const today = new Date();
  const thirtyDaysFromNow = new Date();
  thirtyDaysFromNow.setDate(today.getDate() + 30);

  // Karena data dari API mungkin tidak memiliki field 'ed' langsung,
  // kita perlu mengecek struktur data yang sebenarnya
  // Untuk sekarang, kita akan menampilkan semua item dengan stok_expired > 0
  const expiredItems = data
    .filter((item) => {
      // Filter item yang memiliki stok_expired > 0
      return item.stok_expired && item.stok_expired > 0;
    })
    .slice(0, 10); // Limit to 10 items

  if (expiredItems.length === 0) {
    return (
      <Alert color="success">
        <strong>Baik!</strong> Tidak ada obat yang expired atau mendekati
        expired.
      </Alert>
    );
  }

  const getExpiredBadge = (stokExpired) => {
    if (stokExpired > 0) {
      return <Badge color="danger">Expired ({stokExpired})</Badge>;
    }
    return <Badge color="info">Aman</Badge>;
  };

  return (
    <div>
      <Alert color="warning" className="mb-3">
        <strong>Peringatan!</strong> Ditemukan {expiredItems.length} obat yang
        expired atau mendekati expired.
      </Alert>
      <Table responsive size="sm">
        <thead>
          <tr>
            <th>Nama Obat</th>
            <th>Stok Ready</th>
            <th>Stok Expired</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {expiredItems.map((item, index) => {
            return (
              <tr key={index}>
                <td>{item.nama || "N/A"}</td>
                <td>{item.stok_ready || 0}</td>
                <td>{item.stok_expired || 0}</td>
                <td>{getExpiredBadge(item.stok_expired)}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}
